import './Projects.scss';
import Card from '../Card';
import Section from '../Section';
import { img_agriscan, img_cardjitsu, img_barafpaani } from '../../images64';

const getCodeMarkup = (text: string) => <code className="pill">{text}</code>;

export default function Projects() {
    return <Section title='Projects'>
        <Card className="project">
            <div className='title-wrapper'>
                <h3 className='project-title'>Code Embeddings x JSLite</h3>
            </div>
            <div className='description-wrapper'>
                <p className='text'>
                    Built a robust natural language processing model using DistilBert and HuggingFace to perform 
                    fine-tuning <span className="text -bold">code-functionality classification</span> tasks with an F1 score of 0.93. 
                    Transformed a machine learning model through pre-training to extract source-code embeddings that could be used for general purpose 
                    supervised fine-tuning tasks. 
                    <br/>
                    <br/>
                    Established a benchmark by analyzing 1000+ cloned websites for evaluating state-of-the-art webpage acceleration tools. 
                    Accelerated web pages for low-end mobile devices through classification of functional scripts using a fine-tuned DistilBert
                    model.
                    <br/>
                    <br/>
                    {getCodeMarkup('Python')} {getCodeMarkup('Bert')} {getCodeMarkup('HuggingFace')}
                </p>
            </div>
        </Card>
        <Card className="project" showIcon={true}>
            <a className="link" href="https://devpost.com/software/hackathon-6gkwix" target='_blank'>
                <div className='title-wrapper'>
                    <h3 className='project-title'>AgriScan</h3>
                </div>
                <div className='description-wrapper'>
                    <p className='text'>
                        Created and deployed a chatbot for the detection of plant diseases through machine learning, as 
                        the <span className='text -highlight'>winning project for a hackathon</span> by Facebook Developer Circles Lahore at CodinGuru 2.0
                        Implemented disease prediction by using FastAI with PyTorch, deployed through MEVN stack.
                        <br/>
                        <br/>
                        {getCodeMarkup('MongoDB')} {getCodeMarkup('Express.js')} {getCodeMarkup('Vue')} {getCodeMarkup('Node.js')}
                        {getCodeMarkup('FastAI')} {getCodeMarkup('PyTorch')}
                    </p>
                    <img className='img' src={img_agriscan}/>
                </div>
            </a>
        </Card>
        <Card className="project">
            <div className='title-wrapper'>
                <h3 className='project-title'>Baraf Paani</h3>
            </div>
            <div className='description-wrapper'>
                <p className='text'>
                    Created a <span className="text -bold">real-time multiplayer</span> game based on a south asian rendition of the game 'tag'. Managed project using Trello and created 3D assets.
                    Handled multiplayer using Unity's lobby system and UNet (deprecated).
                    <br/>
                    <br/>
                    {getCodeMarkup('Unity')} {getCodeMarkup('C#')} {getCodeMarkup('UNet')}
                </p>
                <img className='img' src={img_barafpaani}/>
            </div>
        </Card>
        <Card className="project">
            <div className='title-wrapper'>
                <h3 className='project-title'>Card Jitsu</h3>
            </div>
            <div className='description-wrapper'>
                <p className='text'>
                    Developed a turn-based LAN replica of the minigame CardJitsu from Disney's Club Penguin.
                    <br/>
                    <br/>
                    {getCodeMarkup('Unity')} {getCodeMarkup('C#')} {getCodeMarkup('UNet')}
                </p>
                <img className='img' src={img_cardjitsu}/>
            </div>
        </Card>
    </Section>;
};